import * as _ from 'lodash';
import * as api from './../api/api.service';

interface MemberSummary {
  id: number;
  name: string;
  combinedMarketShare: number;
  memberPlanId: number;
  sellerImpacts: any;
}

interface MemberWithPuckDetails extends MemberSummary {
  // id: number;
  // name: string;
  // combinedMarketShare: number;
  // memberPlanId: number;
  plannedSpend: number;
  savings: number;
  continuedSpend: number;
  meetsTargetMarketShare: boolean;
  allocatedMarketShare?: number;
  incumbentPlannedSpendLevel?: number;
  targetMarketShare: number;
  activeSellerImpact: any;
  conversionsNeededCount: number;
}

export default class OfferImpactService {
  aptitudeNegativeColor = this.colors.aptOrange;

  constructor(
    protected $http,
    protected jsendHttpInterceptor,
    protected $q,
    protected api: api.IApiService,
    private colors,
    protected LoadingIndicator,
    $routeParams
  ) {
    'ngInject';
  }

  // We're calculating a lot of percentages, this handles it and handles the _frequent_ case where the denominator
  // is zero so we don't get Infinity.
  percentOrZero(numerator, denominator) {
    if (denominator !== 0) {
      // Oddly enough, at the moment calculations for some of our percentages can end up greater than 100%.
      // In those cases we max out at 100%.
      var percentage = Math.round((numerator / denominator) * 100.0);
      return Math.min(percentage, 100);
    } else {
      return 0;
    }
  }

  // Exposed only for testing and not intended for direct calls
  loadMicroChartData(
    offerId: number,
    partnerId: number,
    usePrimaryEquivalentCrosses: boolean = false
  ) {
    return this.api.offers.getMicrochart(
      offerId,
      partnerId,
      usePrimaryEquivalentCrosses
    );
  }

  loadParticipants(rfpId) {
    return this.$http.get('/aptitude/api/rfps/' + rfpId + '/participants');
  }

  isLeader(account) {
    return account && account.isLeader;
  }

  // Do we need this still? Some of this should be under the overview component now
  getOverviewData() {
    return {
      marketShare: null,
      duration: {
        priceType: null,
        duration: null
      },

      totalCount: 0,

      notSavingCount: 0,

      totalSpend: 0,
      totalPotentialSpend: 0,

      targetPotentialMarketShare: 0,

      metTargetMarketShare: 0, // the number that have met target market share

      total12MonthGroupSavings: 0,

      selectedTier: null,

      dials: {
        notSaving: {
          percentage: 0,
          number: 0,
          color: this.aptitudeNegativeColor
        },
        abilityToReachTarget: {
          percentage: 0,
          number: 0,
          numberIsPercentage: true,
          label: 'Target %',
          color: this.aptitudeNegativeColor
        }
      }
    };
  }

  getParticipantPucks(participants) {
    let pucks = [];

    let includedMembers = _.filter(participants.members, {
      included: true
    });

    _.each(includedMembers as any, (member: any) => {
      let puck = {
        name: member.profile.name,
        id: member.profile.id,

        // Used to know when to refresh facilities and benchmark data.
        dirty: true,

        savingsDisplay: {
          savingsAmount: 0
        }
      };

      pucks.push(puck);
    });

    return pucks;
  }

  noSpend(puck) {
    // This condition is valid for seller side only, check to be sure what buyer side should be
    return (
      puck.savings == null ||
      (puck.savings === 0 &&
        (puck.continuedSpend == null || puck.continuedSpend === 0))
    );
  }

  // Use this instead of assign data to overview above
  getMicroChartLabel(marketSharePct) {
    // TODO: Use tier instead?
    return 'Target ' + marketSharePct + '%';
  }
}
